import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangePasswordAuthComponent } from './change-password-auth/change-password-auth.component';

const routes: Routes = [
  {
    path: '',
    component: ChangePasswordAuthComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChangePasswordAuthRoutingModule {}
